/**
 * Deterministic RNG helper shared by shuffling and zone placement.
 * Lehmer / Park-Miller LCG – wystarczająco dobry do rozkładu w grze,
 * a przy podanym seedzie w pełni powtarzalny w testach.
 */
export function seedRandom(seed?: number): () => number {
  if (typeof seed !== 'number') {
    return Math.random;
  }
  let s = seed % 2147483647;
  if (s <= 0) s += 2147483646;
  return function () {
    s = (s * 16807) % 2147483647;
    return (s - 1) / 2147483646;
  };
}
